module.exports = __webpack_public_path__ + "img/declined-trans.4be695cf.svg";